/* eslint-disable max-len */
import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.CompleteTheRhyme.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.CompleteTheRhyme, 56]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.CompleteTheRhyme.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.question = null;
  this.fish = [];
  this.framesContainer = [];
  this.fishRectangles = [];
  this.hook = null;
  this.graphics = null;
};

EDC.Games.CompleteTheRhyme.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CompleteTheRhyme.Scenes.Main.prototype.constructor = EDC.Games.CompleteTheRhyme.Scenes.Main;

const CTR = EDC.Games.CompleteTheRhyme.Scenes.Main.prototype;

CTR.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

CTR.createTemplateUI = function () {
  this.add.sprite(960, 80, 'title');
  this.add.sprite(960, 195, 'instructions');
  this.add.sprite(960, 330, 'question-frame');
  this.add.sprite(560, 720, 'boy');
};

CTR.loadIteration = function () {
  this.addQuestion();
  this.addFish();
  this.addHook();
};

CTR.addFish = function () {
  const { choices } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const fishSprites = this.shuffleSprites();
  const font = {
    font: `50px ${this.gameConfig.font}`,
  };
  for (let i = 0; i < 3; i++) {
    const { x, y } = this.getFishPosition(i);
    const fish = this.add.sprite(x, y, `fish-${fishSprites[i]}`);
    this.itemHover(fish);
    fish.indexKey = i;
    const frameContainer = this.add.container(x + 160, y);
    const answerFrame = this.add.sprite(10, 0, 'answer-frame').setScale(0.7);
    const text = this.add.text(0, 0, choices[i], font).setOrigin(0.5);
    frameContainer.add(answerFrame);
    frameContainer.add(text);
    this.itemHover(frameContainer);
    fish.answerWord = choices[i];
    const fishRectangle = new Phaser.Geom.Rectangle(x - 40, y - 30, 320, 50);

    this.fishRectangles.push(fishRectangle);
    this.fish.push(fish);
    this.framesContainer.push(frameContainer);
  }
};

CTR.itemHover = function (item) {
  const tween = this.tweens.add({
    targets: item,
    y: item.y - 12,
    duration: 1000,
    ease: 'Sine.easeInOut',
    repeat: -1,
    yoyo: true,
  });
};

CTR.getFishPosition = function (index) {
  const fishPosition = {
    0: { x: 1000, y: 725 },
    1: { x: 1500, y: 750 },
    2: { x: 1200, y: 900 },
  };
  return fishPosition[index];
};

CTR.shuffleSprites = function () {
  const shuffledArray = new Array(7);
  for (let i = 0; i < 7; i++) {
    const j = Math.round(Math.random() * 6);
    if (shuffledArray.includes(j)) {
      i--;
    } else {
      shuffledArray[i] = j;
    }
  }
  return shuffledArray;
};

CTR.addQuestion = function () {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let text = this.make.text({
    x: 250,
    y: 250,
    text: question,
    origin: { x: 0, y: 0 },
    style: {
      fontFamily: `${this.gameConfig.font}, Arial`,
      fontSize: '76px',
      wordWrap: { width: '1500' },
      lineSpacing: 15,
    },
  });
  this.question = text;
};

CTR.addHook = function () {
  const graphics = this.add.graphics({ lineStyle: { width: 2, color: 0x2266aa } });
  this.graphics = graphics;
  this.hook = this.add.sprite(708, 430, 'hook').setOrigin(0.7, 0);
  this.hookAnimation();
  const rect = new Phaser.Geom.Rectangle(-50, 0, 90, 90);
  this.hook.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(this.hook);
  this.input.setDraggable(this.hook);
  this.hook.on(
    'drag',
    ((sprite, pointer, x, y) => {
      graphics.clear();
      sprite.setPosition(x, y);
      const line = new Phaser.Math.Vector2(708, 430);
      graphics.lineStyle(2, 0x00aa00);
      graphics.lineBetween(708, 430, pointer.x, pointer.y);
    }).bind(this, this.hook),
  );

  this.hook.on('dragend', this.onDragStop.bind(this), this);
  this.hook.on('dragstart', this.onDragStart.bind(this), this);
};

CTR.update = function () {
  if (this.hook) {
    this.graphics.clear();
    const line = new Phaser.Math.Vector2(708, 430);
    this.graphics.lineStyle(4, 0x000000);
    this.graphics.lineBetween(708, 430, this.hook.x, this.hook.y);
  }
};

CTR.onDragStart = function (pointer) {
  this.tweens.killTweensOf(this.hook);
};

CTR.onDragStop = function (pointer) {
  let selectedFish;
  let validAnswer = false;
  const hookRect = new Phaser.Geom.Rectangle(this.hook.x, this.hook.y, 100, 90);
  for (let i = 0; i < 3; i++) {
    if (Phaser.Geom.Intersects.RectangleToRectangle(hookRect, this.fishRectangles[i])) {
      selectedFish = this.fish[i];
      validAnswer = true;
    }
  }
  if (validAnswer) {
    this.checkAnswer(selectedFish);
  } else {
    this.releaseHook();
  }
};

CTR.releaseHook = function () {
  this.hook.angle = 0;
  const tween = this.tweens.add({
    targets: this.hook,
    x: 708,
    y: 430,
    duration: 800,
    ease: 'Sine.easeInOut',
    onComplete: this.hookAnimation.bind(this),
  });
};

CTR.reelFish = function (fish) {
  this.tweens.killTweensOf(fish);
  const tween = this.tweens.add({
    targets: fish,
    x: 708,
    y: 490,
    duration: 800,
    ease: 'Sine.easeInOut',
    onComplete: this.adjustFishDepth.bind(this, fish),
  });
};

CTR.adjustFishDepth = function (fish) {
  fish.setDepth(1);
};

CTR.checkAnswer = function (fish) {
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const answer = fish.answerWord;
  if (answer === correctAnswer) {
    this.playCorrect();
    this.framesContainer[fish.indexKey].destroy();
    this.reelFish(fish);
    this.releaseHook();
    this.hook.disableInteractive();
    this.flashAnswer(answer);
    this.time.addEvent({ delay: 3000, callback: this.nextIteration, callbackScope: this });
  } else {
    this.playWrong();
    this.wrongAnimation(fish);
  }
};

CTR.flashAnswer = function (answer) {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let newText = question.replace('__', answer);
  this.question.setText(newText);
};

CTR.nextIteration = function () {
  this.question.destroy();
  this.question = null;
  this.fish.map((x) => {
    x.destroy();
    return true;
  });
  this.fish = [];
  this.framesContainer.map((x) => {
    x.destroy();
    return true;
  });
  this.framesContainer = [];
  this.fishRectangles = [];
  this.hook.destroy();
  this.hook = null;
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

CTR.wrongAnimation = function (fish) {
  this.releaseHook();
  this.tweens.killTweensOf(fish);
  this.tweens.killTweensOf(this.framesContainer[fish.indexKey]);
  this.framesContainer[fish.indexKey].first.setTint(0xff0000);
  this.framesContainer[fish.indexKey].last.setTint(0xff0000);
  fish.setTint(0xff0000);
};

CTR.hookAnimation = function () {
  const tween = this.tweens.add({
    targets: this.hook,
    angle: this.hook.angle - 15,
    duration: 800,
    ease: 'Sine.easeInOut',
    repeat: -1,
    yoyo: true,
  });
};

export default EDC.Games.CompleteTheRhyme.Scenes.Main;
